import {
    OPENTOK_REQUESTED, OPENTOK_REQUEST_FAILED, OPENTOK_REQUEST_SUCCEEDED, RECORDING_START_FAILED,
    RECORDING_START_REQUESTED, RECORDING_START_SUCCEEDED,
    RECORDING_STOP_FAILED, RECORDING_STOP_REQUESTED, RECORDING_STOP_SUCCEEDED, PERMISSIONS_SET,
} from '../constants'


export const opentok = (state = {}, action) => {
    switch (action.type) {
        case OPENTOK_REQUESTED:
            return { ...state, requesting: action.payload.requesting }
        case OPENTOK_REQUEST_FAILED:
            return { ...state, requesting: action.payload.requesting, error: action.payload.error, errorMsg: action.payload.errorMsg }
        case OPENTOK_REQUEST_SUCCEEDED:
            return { ...state, data: action.payload.data, requesting: action.payload.requesting }
        case PERMISSIONS_SET:
            return Object.assign({}, state, { Permissions: action.payload })
        default:
            return state
    }
}


export const recording = (state = {}, action) => {
    switch (action.type) {
        case RECORDING_START_FAILED:
            return action.payload
        case RECORDING_START_REQUESTED:
            return action.payload
        case RECORDING_START_SUCCEEDED:
            return action.payload
        case RECORDING_STOP_FAILED:
            return action.payload
        case RECORDING_STOP_REQUESTED:
            return action.payload
        case RECORDING_STOP_SUCCEEDED:
            return action.payload
        default:
            return state
    }
}

